import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Item = styled.div`
  display: flex;
  margin: 0 10px 10px;
  color: ${(props) => (props.active ? '' : '#B8B3AD')};
  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
`;

const ColorBox = styled.div`
  display: block;
  width: 10px;
  height: 10px;
  margin: 2px 8px 0 0;
  background: ${(props) => (props.active ? props.color : '#B8B3AD')};
`;

const Label = styled.div`
  flex: 1;
  font-size: 12px;
`;

const LegendItem = ({ className, active, color, label, onClick, style }) => {
  return (
    <Item className={className} onClick={onClick ? () => onClick() : undefined} style={style}>
      <ColorBox active={active} color={color} />
      <Label>{label}</Label>
    </Item>
  );
};

LegendItem.propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  color: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

export default LegendItem;
